export default __webpack_public_path__ + "static/media/Mar-Business_6a.f5780530.png";